var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"maintenance"},[_c('h1',[_vm._v("We’ll be back soon!")]),_c('br'),_c('div',[_c('p',[_vm._v("Sorry for the inconvenience but we’re performing some maintenance at the moment. If you need to you can always contact out support, otherwise we’ll be back online shortly!")]),_c('p',[_vm._v("— Team eAcademyNepal")])])])
}]

export { render, staticRenderFns }